import viewPhoto from 'src/common/js/viewPhoto';
import { GetERP_OrderById } from '@api/orderApi.js';
import NProgress from 'nprogress';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import $http from '$http';

export default {
    data() {
        return {
            sysSid: "",
            sysSession: "",
            OrderData: {},
            IsShow: false,
            PictureVisible: false,
            dialogImageUrl: '',
            refundData: [],
            status:0,
            newsList:[],
            changePic:[]
        }
    },
    computed: {
        getAllPrice() {
            return 120;
        },
        isShowClassNum() {
            if (this.OrderData.PackageId != 106 && this.OrderDataProjectType == 2) {
                return true;
            }
            return false;
        },
        isShowJszdByPolicyType() {
            if (this.OrderData.PackageId == 101) {
                return true;
            }
            return false;
        },
        isShowIsFirst() {
            if (this.OrderData.IsFirst > 0) {
                return true;
            }
            return false;
        },
        UnionRentListShow() {
            let PackageId=this.OrderData.PackageId;
            if (PackageId==110 || PackageId==111|| PackageId==112|| PackageId==113) {
                return true;
            }
            return false;
        }
    },
    methods: {
        getList() {
            let param = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, Id: this.$route.query.Id}
            $http.get('api/Order/GetReturnOrderById',param).then(res => {
                util.doResult(this, res, () => {
                    this.OrderData = res.data.Data;
                    this.status=this.OrderData.ReturnStatus
                    let $obj=this.OrderData.ReturnProductInitList;
                    for(let i=0;i<$obj.length;i++){
                        $obj[i].ReturnPro = $obj[i].ReturnProName + '*' + $obj[i].ReturnNum
                        $obj[i].ChangePro = $obj[i].ChangeProName + '*' + $obj[i].ReturnNum
                    }
                    if(this.OrderData.ReturnPic!==null){
                        this.changePic=this.OrderData.ReturnPic.split(',');
                    }
                    if(this.OrderData.ReturnStatus==10){
                        this.OrderData.ReturnProductNewList=[]
                    }
                    //this.newsList=cloneDeep(this.OrderData.ReturnProductNewList)
                    // let $obj2=this.OrderData.ReturnProductNewList;
                    // for(let i=0;i<$obj2.length;i++){
                    //     $obj2[i].ChangePro = $obj2[i].ChangeProName + '*' + $obj2[i].ChangeNum
                    // }
                    // for(let i=0;i<this.OrderData.ReturnNewHistory.length;i++){
                    //     this.OrderData.ReturnNewHistory[i].ChangePro=this.OrderData.ReturnNewHistory[i].ChangeProName+'*'+this.OrderData.ReturnNewHistory[i].ChangeProNum
                    // }
                });
            });
        },
        viewSure() {
            window.history.go(-1);
        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{ src: img.Url, id: "" }]
            });
        }
    },
    created() {
        this.getList();
        this.$store.dispatch("getRouterName", "换货确认查看");
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/Exchange/components/ExchangeViewOrder/vm.js